export var EMPTY_OBJECT = Object.freeze(Object.create(null));
export var EMPTY_ARRAY = [];
export var UNDEFINED = void 0;
export var NOOP = function NOOP() {};
//# sourceMappingURL=const.js.map